import React from 'react';

import {
  SuspendStartOverCancelContext,
  SuspendStartOverCancel
} from '@smart-tv/contexts/suspend-start-over-cancel-context/suspend-start-over-cancel-context';

export const useSuspendStartOverCancel = (): SuspendStartOverCancel => {
  const values = React.useContext(SuspendStartOverCancelContext);

  return { ...values };
};

export default useSuspendStartOverCancel;
